import store from "@/store/vuex"



function goToNextPage() {

    const currentPage = store.state.page.index
    const page2_name = store.state.page.path[1].name


    if (currentPage == 1) {
        return checkIfPage1Complete()
    } else if (currentPage == 2 && page2_name == 'step2_once') {
        return checkIfPage2OnceComplete()
    } else if (currentPage == 2 && page2_name == 'step2_recurring') {
        return checkIfPage2RecurringComplete()
    }
    else if (currentPage == 3) {
        return checkIfPage3Complete()
    }
}

function checkIfPage1Complete() {
    const p_info = store.state.payment_info
    const u_info = store.state.user_info

    if (p_info.amount == -1) {
        return false
    }
    if (p_info.type_payment == null) {
        return false
    }

    if (u_info.type_customer == null) {
        return false
    }

    return true
}


function checkIfPage2OnceComplete() {
    const u_info = store.state.user_info

    if (u_info.firstname == null) {
        return false;
    }
    if (u_info.lastname == null) {
        return false;
    }
    if (u_info.email == null) {
        return false;
    }

    return true;


}

function checkIfPage2RecurringComplete() {
    const u_info = store.state.user_info


    if (u_info.firstname == null) {
        return false;
    }
    if (u_info.lastname == null) {
        return false;
    }
    if (u_info.streetname == null) {
        return false;
    }
    if (u_info.housenumber.number == null) {
        return false;
    }
    if (u_info.postalcode == null) {
        return false;
    }
    if (u_info.city == null) {
        return false;
    }
    if (u_info.email == null) {
        return false;
    }
    if (u_info.birthday.day == null) {
        return false;
    }
    if (u_info.birthday.month == null) {
        return false;
    }
    if (u_info.birthday.year == null) {
        return false;
    }

    return true;

}


function checkIfPage3Complete() {
    const p_info = store.state.payment_info
    if (p_info.payment_option == null) {
        return false;
    }
    if (p_info.agree == false) {
        return false;
    }
    return true
}

export default {
    goToNextPage,
}
